import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from './langs/en'
import zhLocale from './langs/zh'

Vue.use(VueI18n)

const messages = {
  en: {
    ...enLocale
  },
  zh: {
    ...zhLocale
  }
}

// 获取浏览器语言设置
const getBrowserLang = function() {
  const browserLang = navigator.language || navigator.userLanguage
  const defaultBrowserLang = browserLang.toLowerCase()
  if (defaultBrowserLang === 'zh-cn' || defaultBrowserLang === 'zh') {
    return 'zh'
  } else {
    return 'en'
  }
}

// 从localStorage获取语言设置
const lang = localStorage.getItem('lang') || getBrowserLang()

const i18n = new VueI18n({
  locale: lang,  // 设置语言
  messages,      // 设置语言包
  silentTranslationWarn: true // 禁用翻译警告
})

export default i18n